export default __webpack_public_path__ + "static/media/visa.fe10bf5a.svg";